import { Component, effect, inject } from '@angular/core';
import { DynamicStylerService } from '@sds/dynamic-styler';
import { PortalSettingsStore } from '@sds/shared';
import { Theme } from '@sds/shared/enums';
import { SystemMediaService } from '@sds/shared/services';
import { UserSettingsStore } from '@sds/user-settings';
import { RouteHandlerComponent } from '../route-handler/route-handler.component';

@Component({
  imports: [RouteHandlerComponent],
  selector: 'sds-theme-handler',
  templateUrl: './theme-handler.component.html',
  styleUrl: './theme-handler.component.scss',
  providers: [DynamicStylerService]
})
export class ThemeHandlerComponent {
  private readonly userSettingsStore = inject(UserSettingsStore);
  private readonly portalSettingsStore = inject(PortalSettingsStore);
  private readonly systemMediaService = inject(SystemMediaService);
  private readonly dynamicStylerService = inject(DynamicStylerService);

  constructor() {
    effect(() => {
      this.dynamicStylerService.applyTheme(
        this.userSettingsStore.theme(),
        this.systemMediaService.prefersColorScheme()
      );
    });

    effect(() => {
      this.dynamicStylerService.applyCssVars(this.userSettingsStore.theme(), this.portalSettingsStore.themeColors());
    });

    effect(() => {
      if (this.userSettingsStore.theme() === Theme.System) {
        this.dynamicStylerService.applyCssVars(
          this.systemMediaService.prefersColorScheme() === 'dark' ? Theme.Dark : Theme.Atomic,
          this.portalSettingsStore.themeColors()
        );
      }
    });
  }
}
